var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"help-tip",attrs:{"tabindex":"0","role":"note","aria-label":_vm.text}},[_vm._v(" ? "),_c('md-tooltip',{staticClass:"help-tip-bubble",attrs:{"md-direction":"top","md-delay":0}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }